export default __webpack_public_path__ + "static/media/arrow-cursor-move.cd7ce41f.svg";